module.exports = __webpack_public_path__ + "static/media/image-2.68566430.png";